import { Component, ElementRef} from '@angular/core';
import { PopoverController } from '@ionic/angular'
import { ResourcesProvider } from '../../providers/resources/resources.provider';
import { TeachingTool } from '../../models/teaching-tool';
import { Filters, FilterSection, FilterItem } from 'src/app/components/resources-filter/resources-filter.component';
import { plainToClass } from 'class-transformer';
import { ResourcesBase } from '../resources/resources-base.page';
import { ResourcesCssService } from '../resources/resources-css.service'
import { WindowService } from '../../services/window.service'
import { ResourceSortItem } from 'src/app/components/resources-header/resources-header.component';
import { ResourceStore } from 'src/app/stores/resources.store';

@Component({
  selector: 'app-teaching-tools',
  templateUrl: './teaching-tools.page.html',
  styleUrls: ['./teaching-tools.page.scss'],
})
export class TeachingToolsPage extends ResourcesBase<TeachingTool> {

  constructor(element: ElementRef,
              resourcesProvider: ResourcesProvider,
              resourcesCssService: ResourcesCssService,
              windowService: WindowService,
              private popoverCtrl: PopoverController,
              protected resourceStore: ResourceStore) {
    super(element, resourcesProvider, resourcesCssService, windowService, resourceStore)
    this.sortName = 'Date Modified'
  }

  items(): TeachingTool[] {
    return this.resources.teachingTools.filter((tool: TeachingTool) => (tool.uuid.length > 5) && !tool.tagsList().includes('teachernotes'))
  }

  updateFilters() {
    super.updateFilters()

    const collections = this.collections(this.items())
    const itemsTypes = this.itemsTypes(this.items())
    const categories = this.categories(this.items())

    this.filters = plainToClass(Filters, {
      sections: [
        {
          title: 'Collection',
          items: collections.map( (name: string) => {
            return { title: name }
          }),
        },
        {
          title: 'Tool Type',
          items: categories.map( (name: string) => {
            return { title: name }
          }),
        },
        {
          title: 'Class Type',
          items: itemsTypes.map( (type: string) => {
            return { title: type }
          }),
        }
        
        
        // {
        //   title: 'Content Type',
        //   items: ['Link', 'PDF', 'Video'].map( (type: string) => {
        //     return { title: type }
        //   }),
        //   exclusive: true
        // },
      ],
    })
  }

  categories(items: TeachingTool[]): string[] {
    const categories = new Set<string>()
    items.forEach( (item: TeachingTool) => {
      if (item.category?.trim() != '') {
        categories.add(item.category)
      }
    })
    return Array.from(categories.values()).sort()
  }

  collections(items: TeachingTool[]): string[] {
    const collections = new Set<string>()
    items.forEach( (item: TeachingTool) => {
      if (item.collection?.trim() != '') {
        collections.add(item.collection)
      }
    })
    return Array.from(collections.values()).sort()
  }

  itemsMatchingFilters(items: TeachingTool[], filters: Filters): TeachingTool[] {
    return filters.filter(items, (item: TeachingTool, section: FilterSection, filterItem: FilterItem) => {
      if (section === this.filters.sections[0]) { // collection
        return item.collection.toLowerCase() === filterItem.title.toLowerCase()
      } else if (section === this.filters.sections[1]) { // category
        return item.category.toLowerCase() === filterItem.title.toLowerCase()
      } else if (section === this.filters.sections[2]) { // tools
        return item.typesList().some( (type: string) => type.toLowerCase() === filterItem.title.toLowerCase() )
      }
      return false;
    });
  }

  itemMatchesSearch(item: TeachingTool, searchString: string): boolean {
    return item.name.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
      item.description.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
      item.tags.toLowerCase().indexOf(searchString.toLowerCase()) >= 0
  }

  itemTypes(item: TeachingTool): string[] {
    return item.typesList()
  }

  get sortItems(): ResourceSortItem[] {
    return [
      { name: 'Name', action: () => { this.sortName = 'Name' }},
      { name: 'Collection', action: () => { this.sortName = 'Collection' }},
      { name: 'Category', action: () => { this.sortName = 'Category' }},
      { name: 'Tool', action: () => { this.sortName = 'Tool' }},
      { name: 'Date Modified', action: () => { this.sortName = 'Date Modified' }},
    ]
  }

  itemsSortedBy(items: TeachingTool[], option: string) {
    if (option.length === 0) {
      return items
    }

    return items.sort((a: TeachingTool, b: TeachingTool) => {
      if (option === 'Name') {
        return a.name < b.name ? -1 : 1
      } else if (option === 'Collection') {
        return (a.collection || '').toLowerCase() < (b.collection || '').toLowerCase() ? -1 : 1
      } else if (option === 'Category') {
        return (a.category || '').toLowerCase() < (b.category || '').toLowerCase() ? -1 : 1
      } else if (option === 'Tool') {
        return (a.firstType || '').toLowerCase() < (b.firstType || '').toLowerCase() ? -1 : 1
      } else if (option === 'Date Modified') {
        return (a.synced < b.synced) ? 1 : -1
      } else {
        return a.name < b.name ? -1 : 1
      }
    })
  }

}
